import React from 'react'
import './MainHead.css'

function MainHead({Heading}) {
  return (
    <div className='MainHeading'>{Heading}</div>
  )
}

export default MainHead